<template>
    <div class="container mt-5">
        <div class="mb-2">
            <md-card>
                <!-- <md-ripple> -->
                    <md-card-header>
                    <div class="md-title">Busqueda</div>
                    <!-- <div class="md-subhead">Ingresa </div> -->
                    </md-card-header>

                    <md-card-content>
                        <div class="row pl-5 pr-5">
                            <div class="col-6">
                                <md-field >
                                    <label>Nombre</label>
                                    <md-input v-model="nombreBusqueda" ></md-input>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions>
                    <md-button class="col-2" style="background-color: #9cc4e4; color: #586875;" @click="consultaPendientes">
                        <i class="fas fa-search mr-2"></i>
                        Buscar
                    </md-button>
                    </md-card-actions>
                <!-- </md-ripple> -->
            </md-card>
        </div>
        <div >
          <md-table v-model="pendientes" md-sort="name" md-sort-order="asc" md-card>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Nombre" md-sort-by="Nombre">{{ item.Nombre }}</md-table-cell>
                <md-table-cell md-label="Apellido Paterno" md-sort-by="Apellido Paterno">{{ item.ApellidoPaterno }}</md-table-cell>
                <md-table-cell md-label="Apellido Materno" md-sort-by="Apellido Materno">{{ item.ApellidoMaterno }}</md-table-cell>
                <md-table-cell md-label="Fecha de Nacimiento">{{ item.FechaNacimiento }}</md-table-cell>
                <md-table-cell md-label="Sexo" md-sort-by="Sexo">{{ item.Sexo }}</md-table-cell>
              <md-table-cell md-label="Estado Civil" md-sort-by="Estado Civil">{{ item.EstadoCivil }}</md-table-cell>
              <md-table-cell md-label="Estatus">{{ item.Estatus }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
        <SuccessModal
        :showDialog="showSuccess"
        :mensaje="mensajeSuccess"
        :reloadPage="reloadPage"
        />
        <ErrorModal
        :showDialog="showError"
        :mensaje="mensajeError"
        />
        <AlertModal
        :showDialog="showAlert"
        :mensaje="mensajeAlert"
        />
        <Loading :isLoading="isLoading"/>
    </div>
  </template>
  
  <script>
  import SuccessModal from "./Modals/successModal.vue";
  import ErrorModal from "./Modals/errorModal.vue";
  import AlertModal from "./Modals/alertModal.vue";
  import Loading from "./Tools/loading.vue";

    export default {
      name: 'TableSort',
      components: {
        Loading,
        SuccessModal,
        ErrorModal,
        AlertModal,
    },
      data: () => ({
        nombreBusqueda: '',
        isLoading: false,
        //Alertas
        showAlert: false,
        mensajeAlert: '',
        showError: false,
        mensajeError: '',
        showSuccess: false,
        mensajeSuccess: '',
        reloadPage: false,
        pendientes: [],
        inicial: '',
        final: '',
        errors: {
            inicial: false,
            final: false
        },
      }),
      methods:{
        async consultaPendientes() {
          this.pendientes = []
          this.isLoading = true;
          const payload = {
              metodo: "CONSULTAPENDIENTESISEP",
              data: {
                busquedaNombre: this.nombreBusqueda
              },
          };
          try {
          const response = await this.$store.dispatch("metodoPost", payload);
              if (response) {
                  const res = this.$store.getters.getRespuestaREST;
                  console.log(res);
                  if (res.length <= 0) {
                      this.isLoading = false;
                      this.showAlert = true;
                      this.mensajeAlert = "No se encontro información."
                      setTimeout( () => {this.showAlert = false;}, 5000)
                      return;
                  }
                  this.pendientes = res
              }
              else {
                this.isLoading = false;
                this.showError = true
                this.mensajeError = 'Hubo un error en la busqueda.'
                setTimeout( () => {this.showError = false;}, 5000)
              }
          } //Fin try
          catch (error) {
            this.isLoading = false;
              console.log(error);
          }
          this.isLoading = false;
        },
        exportToCSV() {
          // Crear los encabezados del CSV a partir de las claves del primer objeto
          const headers = Object.keys(this.reportes[0]).join(',');
          
           // Crear las filas del CSV con sustitución de true/false por "Sí"/"No"
          const rows = this.reportes.map(obj => 
            Object.values(obj).map(val => {
              if (val === true) return '"Sí"';  // Sustituir true por "Sí"
              if (val === false) return '"No"'; // Sustituir false por "No"
              return `"${val || ''}"`;           // Para otros valores (incluyendo null)
            }).join(',')
          ).join('\n');
          
          // Combinar los encabezados y las filas
          const csvContent = headers + '\n' + rows;

          // Crear un blob con el contenido CSV
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          
          // Crear un enlace para descargar el archivo
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute('download', 'reporte.csv');

          // Añadir el enlace al documento y simular un clic
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace
          document.body.removeChild(link);
        },
      },
      computed: {
        // errorClasses() {
        //     return {
        //         poliza: this.errors.inicial ? 'md-invalid' : '',
        //         nombre: this.errors.final ? 'md-invalid' : '',
        //     };
        // }
    },
    }
  </script>

<style>

</style>